
import { useContext } from 'react';
import { useAuthentication } from '../../Hooks';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import ActividadesContainer from '../Actividad/ActividadContainer';
import Actividad from '../Actividad/Actividad';
import { ActividadesContext } from '../../Contexts';

export function SolicitudesSection({ fuente, referencia, crearNuevo }) {
    let actividadesContext = useContext(ActividadesContext);
    let onContextRefresh;
    const { usuario } = useAuthentication();
    
    if (actividadesContext) {
        onContextRefresh = actividadesContext.onContextRefresh;
    }
    return (
        <>
            <>
                    <div className='d-flex justify-content-end' style={{paddingBottom: '15px'}}>
                        <AnimatedIconButton
                            onClick={crearNuevo}
                            iconName="create"
                            message="Crear"
                            size="30px"
                            height="15px"
                            width="15px"
                        />
                    </div>
                    <ActividadesContainer
                        {...{
                            where: {
                                fuente: fuente,
                                referencia: referencia,
                                cronologia: "P",
                                EsPaginable: false,
                            },
                            showLoading: () => {},
                            hideLoading: () => {},
                            label: `Pasadas`,
                            recargar: onContextRefresh,
                        }}
                    >
                        <Actividad />
                    </ActividadesContainer>
                    <ActividadesContainer
                        {...{
                            where: {
                                fuente: fuente,
                                referencia: referencia,
                                cronologia: "H",
                                EsPaginable: false,
                            },
                            showLoading: () => {},
                            hideLoading: () => {},
                            isActive: true,
                            label: `Hoy`,
                            recargar: onContextRefresh,
                        }}
                    >
                        <Actividad />
                    </ActividadesContainer>
                    <ActividadesContainer
                        {...{
                            where: {
                                fuente: fuente,
                                referencia: referencia,
                                cronologia: "F",
                                EsPaginable: false,
                            },
                            showLoading: () => {},
                            hideLoading: () => {},
                            label: `Futuras`,
                            recargar: onContextRefresh,
                        }}
                    >
                        <Actividad />
                    </ActividadesContainer></>
        </>
    );
}

